import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { ChartModule } from 'angular2-highcharts';
import { HighchartsStatic } from 'angular2-highcharts/dist/HighchartsService';
import { ConfirmDialogModule, ConfirmationService, GrowlModule } from 'primeng/primeng'; // Import NgCha

import { Select2Module } from 'ng2-select2';

// Service
import { HelperModule } from '../../../common/helper/helper.module';
import { EvsAddressService } from '../../../common/services/EvsAddress.service';
import { UploadService } from '../../../common/services/Upload.service';
// Component
import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
import { InfiniteScrollModule } from 'angular2-infinite-scroll';
import { DashboardComponent } from './dashboard/dashboard.component';
import { Page401Component } from './page-error/page-401-component';

import { SortHeaderModule } from 'app/common/sort-header/sort-header.module';
import { AppTagsInputModule } from 'app/common/tags-input/tags-input.module';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { PopoverModule } from 'ngx-popover';
import { TagsInputModule } from 'ngx-tags-input/dist';
import { BlockModule } from '../../../layout/block';
import { CardModule } from '../../../layout/card';
import { AnalyticComponent } from './analytic/analytic.component';
import { CampaignModule } from './campaign/campaign.module';
import { ChatModule } from './chat/chat.module';
import { ContactModule } from './contact/contact.module';
import { CustomerComponent } from './customer/customer.component';
import { MailboxComponent } from './email/mailbox.component';
import { AgentComponent } from './report/agents/agent.component';
import { ChannelComponent } from './report/channels/channel.component';
import { ContactComponent } from './report/contacts/contact.component';
import { ReportComponent } from './report/report.component';
import { ServiceComponent } from './report/services/service.component';
import { SummaryComponent } from './report/summary/summary.component';
import { TicketComponent } from './report/tickets/ticket.component';
import { SanitizedHtmlPipe } from './sanitized.pipe';
import { ScoreModule } from './score/score.module';
import { SearchComponent } from './search/search.component';
import { SettingsModule } from './setting/settings.module';
import { UserSharedService } from './customer/UserSharedService';
import { ComponentsModule } from '../../../components/component.module';
import { FilterComponent } from './report/filter/filter.component';
import { HistoryComponent } from './report/history/history.component';
import { TicketsComponent } from './tabs/organize/tickets/tickets.component';
import { UsersComponent } from './tabs/organize/users/users.component';
import { ContactsComponent } from './tabs/organize/contacts/contacts.component';
import { MonitorsModule } from './monitors/monitors.module';
import { SmartQcModule } from './smart-qc/smart-qc.module';
import { MonitorsModulev2 } from './reportv2/reportv2.module';

import { TicketContactComponent } from './tabs/user/tickets/tickets.component';

declare var require: any;

export function highchartsFactory() {
  const hc = require('highcharts');
  const dd = require('highcharts/modules/drilldown');
  dd(hc);

  return hc;
}

@NgModule({
  imports: [
    CommonModule,
    ChartModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    ConfirmDialogModule,
    GrowlModule,
    BrowserModule,
    HelperModule,
    CardModule,
    BlockModule,
    ModalModule.forRoot(),
    ContactModule,
    SettingsModule,
    Select2Module,
    ChatModule,
    BsDatepickerModule.forRoot(),
    InfiniteScrollModule,
    TooltipModule.forRoot(),
    PopoverModule,
    FroalaEditorModule.forRoot(),
    FroalaViewModule.forRoot(),
    CampaignModule,
    ScoreModule,
    SortHeaderModule,
    AppTagsInputModule.forRoot(),
    ComponentsModule,
    MonitorsModule,
    SmartQcModule,
    MonitorsModulev2,
  ],
  declarations: [
    Page401Component,
    DashboardComponent,
    SummaryComponent,
    TicketComponent,
    ReportComponent,
    ServiceComponent,
    ContactComponent,
    MailboxComponent,
    HistoryComponent,
    FilterComponent,
    AnalyticComponent,
    SearchComponent,
    CustomerComponent,
    SanitizedHtmlPipe,
    ChannelComponent,
    AgentComponent,
    TicketsComponent,
    UsersComponent,
    ContactsComponent,
    TicketContactComponent,
  ],
  exports: [
    TicketComponent,
    SanitizedHtmlPipe,
    FilterComponent,
    TicketsComponent,
    UsersComponent,
    ContactsComponent,
    TicketContactComponent,
  ],
  providers: [
    UserSharedService,
    UploadService,
    EvsAddressService,
    ConfirmationService,
    {
      provide: HighchartsStatic,
      useFactory: highchartsFactory,
    },
  ],
  entryComponents: [],
})
export class IContactModule {}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/iContactModule.ts